import { useState } from 'react'
import { motion } from 'framer-motion'
import type { StepShape as StepShapeType } from '@/types/storytelling'

interface StepShapeProps {
  step: StepShapeType
  onComplete: (choiceId: string) => void
}

export function StepShape({ step, onComplete }: StepShapeProps) {
  const [selected, setSelected] = useState<string | null>(null)

  const handleSelect = (choiceId: string) => {
    setSelected(choiceId)
    onComplete(choiceId)
  }

  return (
    <div className="px-5 py-6">
      <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--color-story-primary-light)' }}>Your turn</p>
      <div className="rounded-2xl p-5 bg-white mb-4" style={{ border: '1px solid var(--color-story-border)' }}>
        <p className="font-semibold text-sm mb-2" style={{ color: 'var(--color-story-text)' }}>Here's a moment:</p>
        <p className="text-sm italic leading-relaxed p-3 rounded-xl" style={{ color: 'var(--color-story-text)', background: 'var(--color-story-bg-light)' }}>"{step.setup}"</p>
      </div>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="rounded-2xl p-5" style={{ background: 'linear-gradient(135deg, var(--color-story-bg), var(--color-story-bg-light))', border: '1px solid var(--color-story-border)' }}>
        <p className="font-semibold text-sm mb-1" style={{ color: 'var(--color-story-text)' }}>{step.prompt}</p>
        <div className="flex flex-col gap-2 mt-3">
          {step.choices.map((choice) => (
            <button key={choice.id} onClick={() => handleSelect(choice.id)} className="rounded-xl p-4 text-left transition-all" style={{ background: selected === choice.id ? 'var(--color-story-primary)' : 'white', border: `2px solid ${selected === choice.id ? 'var(--color-story-primary)' : 'var(--color-story-border)'}` }}>
              <p className="font-semibold text-sm" style={{ color: selected === choice.id ? 'white' : 'var(--color-story-text)' }}>{choice.text}</p>
              <p className="text-xs mt-1 leading-relaxed" style={{ color: selected === choice.id ? 'rgba(255,255,255,0.85)' : 'var(--color-story-text-muted)' }}>{choice.preview}</p>
            </button>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
